import { defineNamespace } from '../core';
import { en } from './en';
import { fr } from './fr';

export const format = defineNamespace('format', fr, en);
